const DEFAULT_LANGUAGE = 'en';
const DEFAULT_REGION = 'US';

export const DEFAULT_LOCALE = `${DEFAULT_LANGUAGE}-${DEFAULT_REGION}`;

const languageToLongLocaleCode: Record<string, string> = {
	cs: 'cs-CZ',
	da: 'da-DK',
	de: 'de-DE',
	en: 'en-US',
	es: 'es-ES',
	fi: 'fi-FI',
	fr: 'fr-FR',
	hu: 'hu-HU',
	it: 'it-IT',
	ja: 'ja-JP',
	ko: 'ko-KR',
	// Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
	no: 'no-NO',
	nb: 'no-NO',
	nl: 'nl-NL',
	pl: 'pl-PL',
	ru: 'ru-RU',
	sv: 'sv-SE',
	th: 'th-TH',
	tr: 'tr-TR',
	uk: 'uk-UA',
	vi: 'vi-VN',
	zh: 'zh-CN',
};

export const normalizeLocale = (locale: string | undefined) => {
	if (!locale) {
		return DEFAULT_LOCALE;
	}

	const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
	if (!match) {
		throw Error('Unable to get language and country from the supplied locale.');
	}
	const [, language, region] = match;

	const normalizedLanguage = (language ?? '').toLowerCase();
	const normalizedRegion = (region ?? '').toUpperCase();

	if (normalizedLanguage && normalizedRegion) {
		return [normalizedLanguage, normalizedRegion].join('-');
	}

	const longLocaleCode = languageToLongLocaleCode[normalizedLanguage];
	return longLocaleCode ?? DEFAULT_LOCALE;
};
